<template>
  <div class="tw:flex tw:items-center tw:gap-1">
    <span
      v-for="(key, index) in keys"
      :key="index"
      class="tw:border tw:border-default-200 tw:bg-white tw:rounded-md tw:caption tw:text-default-700 tw:py-1 tw:px-[0.4rem]"
    >
      {{ key }}
    </span>

    <span class="tw:caption tw:text-default-700">{{ text }}</span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  keys: string[];
  text: string;
}

defineProps<Props>();
</script>
